import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "../../images/logo.svg";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";
import { ReactComponent as SupportIcon } from "../../images/whatsapp-icon.svg";
import { ReactComponent as LinkedIcon } from "../../images/linkedin-icon.svg";
import { ReactComponent as InstaIcon } from "../../images/instagram-icon.svg";
import { ReactComponent as PinterestIcon } from "../../images/pinterest-icon.svg";
import { ReactComponent as SnapchatIcon } from "../../images/snapchat-icon.svg";
import { ReactComponent as TikTokIcon } from "../../images/tiktok-icon.svg";
import { ReactComponent as RedditIcon } from "../../images/reddit-icon.svg";
import { ReactComponent as TelegramIcon } from "../../images/telegram-icon.svg";
import { ReactComponent as DiscordIcon } from "../../images/discord-icon.svg";
import { ReactComponent as TumblrIcon } from "../../images/tumblr-icon.svg";
import { ReactComponent as ThreadsIcon } from "../../images/threads-icon.svg";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const Container = tw(ContainerBase)`bg-[#0049AC] text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-10 lg:py-12`;

const Row = tw.div`flex items-center justify-center flex-col px-8`;

const LogoContainer = tw.div`flex items-center justify-center top-0`;
const LogoImg = tw.img`w-32`;
const LogoText = tw.h5`ml-2 text-sm md:text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10 justify-center`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;

const SocialIcons = {
  facebook: <FacebookIcon />,
  twitter: <TwitterIcon />,
  youtube: <YoutubeIcon />,
  instagram: <InstaIcon />,
  linkedin: <LinkedIcon />,
  whatsapp: <SupportIcon />,
  pinterest: <PinterestIcon />,
  snapchat: <SnapchatIcon />,
  tiktok: <TikTokIcon />,
  reddit: <RedditIcon />,
  telegram: <TelegramIcon />,
  discord: <DiscordIcon />,
  tumblr: <TumblrIcon />,
  threads: <ThreadsIcon />,
};

export default () => {
  const [socialLinks, setSocialLinks] = useState([
    { platform: "facebook", url: "https://facebook.com", flag: true },
    { platform: "twitter", url: "https://twitter.com", flag: true },
    { platform: "youtube", url: "https://youtube.com", flag: true },
    { platform: "instagram", url: "https://instagram.com", flag: true },
    { platform: "linkedin", url: "https://linkedin.com", flag: true },
    { platform: "whatsapp", url: "https://whatsapp.com", flag: true },
    { platform: "pinterest", url: "https://pinterest.com", flag: true },
    { platform: "snapchat", url: "https://snapchat.com", flag: true },
    { platform: "tiktok", url: "https://tiktok.com", flag: true },
    { platform: "reddit", url: "https://reddit.com", flag: true },
    { platform: "telegram", url: "https://telegram.org", flag: true },
    { platform: "discord", url: "https://discord.com", flag: true },
    { platform: "tumblr", url: "https://tumblr.com", flag: true },
    { platform: "threads", url: "https://threads.net", flag: true },
  ]);

  useEffect(() => {

    const fetchSocial = async () => {
      try {
        const response = await fetch(`${API_URL}/web/home/social-links`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();
        const data = result.data;
        if (result.header.resCode === 200 && data.length > 0) {
          const updatedLinks = data.map((linkData) => ({
            platform: linkData.title.toLowerCase(),
            url: linkData.content || "",
            flag: linkData.flag !== false, // Show only if flag is not explicitly false
          }));
          setSocialLinks(updatedLinks);
        }
      } catch (error) {
        console.error("Error fetching links:", error);
      }
    };

    fetchSocial();

  }, []);

  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
            <LogoText>Traviator Holidays</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link href="/pg/know-us">About Us</Link>
            <Link href="/pg/blogs/write">Write Blog</Link>
            <Link href="/pg/privacy-policy">Privacy Policy</Link>
            <Link href="/pg/terms-conditions">Terms & Conditions</Link>
          </LinksContainer>
          <SocialLinksContainer>
            {socialLinks.map(
              (link) =>
                link.flag && (
                  <SocialLink key={link.platform} href={link.url} target="_blank" rel="noopener noreferrer">
                    {SocialIcons[link.platform] || null}
                  </SocialLink>
                )
            )}
          </SocialLinksContainer>
          <CopyrightText>
            &copy; Copyright {(new Date().getFullYear())}, Traviator Holidays. All Rights Reserved.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
